import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";
import QuantityDropdown from "../quantity-dropdown/QuantityDropdown";

const AmountSelector = ({
  amount,
  setAmount,
  salePrice,
  deliver_listing,
  amountError,
  disabled,
}) => {
  const handleDecrementClick = () => {
    if (disabled) return;
    setAmount((prevAmount) => Math.max(1, (prevAmount || 1) - 1));
  };

  const handleIncrementClick = () => {
    if (disabled) return;
    setAmount((prevAmount) => (prevAmount || 0) + 1);
  };

  const handleQuantityChange = (_, selectedNum) => {
    if (disabled) return;
    setAmount(selectedNum);
  };

  return (
    <>
      <div className={"name-amount-div"}>
        <div className={"name"}>
          {deliver_listing?.article_name_and_qualities ||
            deliver_listing?.article?.name}
        </div>
        <div
          className={classNames("amount-div", {
            "amount-div--disabled": disabled,
          })}
        >
          <div className={`units`} style={{ marginRight: "1rem" }}>
            <div>
              {salePrice}
              <sup>*</sup>
            </div>
            {salePrice && (
              <>
                <div>{deliver_listing.stk}</div>
                <span>
                  {deliver_listing.sales_unit_display}&nbsp;
                  {deliver_listing.sales_package_weight}
                </span>
              </>
            )}
          </div>

          <div className={"qts-amount"}>
            <p
              className={classNames("qts-minus", {
                "qts-minus-disabled": amount === 1,
              })}
              onClick={handleDecrementClick}
            >
              -
            </p>
            <QuantityDropdown
              value={amount}
              onNumberSelect={handleQuantityChange}
              numInCartClass={"qts-num"}
              colorSecondary={"inherit"}
              editable={!disabled}
              position={"amount"}
              maxValue={999}
            />
            <p className={"qts-plus"} onClick={handleIncrementClick}>
              +
            </p>
          </div>
        </div>
      </div>
      <div className="price-note">
        <FormattedMessage id="pricesSubjectToChange" />
      </div>
      {amountError && <div className="error-message">{amountError}</div>}
    </>
  );
};

export default AmountSelector;
